module.exports = __webpack_public_path__ + "catalog/items/arrow/arrow.svg";